"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _Devices = _interopRequireDefault(require("./Devices"));
var _Filters = require("../Filters");
var _material = require("@mui/material");
var _constants = require("../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const {
  ComponentTypes,
  filterTypes
} = _paulCorePackage.constants;
const DevicesWrap = () => {
  const [typeDisplay, setTypeDisplay] = (0, _react.useState)(_constants.contentType.layoutGrid);
  const tI = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsInterfaceUILocalizations);
  const filterConfig = (0, _react.useMemo)(() => {
    var _tI$, _tI$2, _tI$3, _tI$4;
    return [
    // { text: 'Warnings', value: 'display_warnings', type: 'button', id: 0, showIf: hasWarning },
    {
      text: (_tI$ = tI[2]) !== null && _tI$ !== void 0 ? _tI$ : '' /* Cold water */,
      name: 'equipmentType',
      value: [ComponentTypes.PwcPoe],
      grouped: true,
      type: filterTypes.button,
      id: '1'
    }, {
      text: (_tI$2 = tI[3]) !== null && _tI$2 !== void 0 ? _tI$2 : '' /* Hot water */,
      name: 'equipmentType',
      value: [ComponentTypes.PwhSupply],
      grouped: true,
      type: filterTypes.button,
      id: '2'
    }, {
      text: (_tI$3 = tI[4]) !== null && _tI$3 !== void 0 ? _tI$3 : '' /* Circulation */,
      name: 'equipmentType',
      value: [ComponentTypes.PwhC, ComponentTypes.PwhPipe],
      grouped: true,
      type: filterTypes.button,
      id: '3'
    }, {
      text: (_tI$4 = tI[10]) !== null && _tI$4 !== void 0 ? _tI$4 : '' /* Heater */,
      name: 'equipmentType',
      value: [ComponentTypes.HtgCc, ComponentTypes.HtgSys, ComponentTypes.PwhSupply, ComponentTypes.HtgHx, ComponentTypes.HtgPipe],
      grouped: true,
      type: filterTypes.button,
      id: '4'
    }];
  }, [tI]);
  const handleSetTypeDisplay = value => {
    setTypeDisplay(value);
  };
  return /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_Filters.FiltersPanel, {
    config: filterConfig,
    objectId: 'thingPDIDDevice',
    typeDisplay: typeDisplay,
    setTypeDisplay: handleSetTypeDisplay
  }), /*#__PURE__*/_react.default.createElement(_Devices.default, {
    typeDisplay: typeDisplay
  }));
};
var _default = exports.default = DevicesWrap;